/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */


import { IAttribute, IAttributeError, IEntityNameSpace, IEnityResources, IDPModel } from "../../../models/Policies/PolicyContract"
import { IEntityFormErrorState, ISelect } from "../../../models/Roles/RolesContracts"
import { SET_POLICY_ENTITIES_FORM_DATA, SET_ENTITIES_LIST, SET_POLICY_ENTITIES_FORM_ERROR, UPDATE_POLICY_ENTITIES_FORM_ERROR, RESET_POLICY_ENTITIES_FORM, SET_ENTITIES_ATTRIBUTES_LIST, ADD_ATTRIBUTE, SET_ATTRIBUTE_FORM_DATA, SET_ATTRIBUTE_ERROR_FORM_DATA, SET_RESOURCE_NS, SET_RESOURCES, ADD_COLUMN_ATTRIBUTE, SET_COLUMN_ATTRIBUTE_ERROR_FORM_DATA, SET_COLUMN_ATTRIBUTE_FORM_DATA, SET_DP_MODEL, RESET_ENTITY_POLICY_ATTRIBUTES, SET_ENTITIES_REMOTE_DATA_URL_OBJECT, SET_REMOTE_URL_RESPONSE_DATA, RESET_REMOTE_URL_RESPONSE_DATA } from "./types"

export const setPolicyEntitiesFormData = (name: string, value: string | ISelect | ISelect[]) => {
  return {
    type: SET_POLICY_ENTITIES_FORM_DATA,
    data: { [name]: value }
  }
}

export const setEntitiesList = (entities: ISelect[]) => {
  return {
    type: SET_ENTITIES_LIST,
    entities
  }
}

export const setEntitiesAttributesList = (attributeList: any[]) => {
  return {
    type: SET_ENTITIES_ATTRIBUTES_LIST,
    attributeList
  }
}
export const setEntitiesAttributesRemoteDataUrlObject = (remoteDataUrlObject: Object) => {
  return {
    type: SET_ENTITIES_REMOTE_DATA_URL_OBJECT,
    remoteDataUrlObject
  }
}

export const setEntityFormError = (errorData: IEntityFormErrorState) => {
  return {
    type: SET_POLICY_ENTITIES_FORM_ERROR,
    errorData
  }
}

export const updateEntityFormError = (name: string, value: string) => {
  return {
    type: UPDATE_POLICY_ENTITIES_FORM_ERROR,
    data: { [name]: value }
  }
}
export const resetEntityFormInitialState = () => {
  return {
    type: RESET_POLICY_ENTITIES_FORM,
  }
}

export const addAttribute = (attribute: IAttribute) => {
  return {
    type: ADD_ATTRIBUTE,
    attribute
  }
}

export const resetEntityPolicyAttributes = () => {
  return {
    type: RESET_ENTITY_POLICY_ATTRIBUTES
  }
}

export const setAttributeFormData = (attributes: IAttribute[]) => {
  return {
    type: SET_ATTRIBUTE_FORM_DATA,
    attributes
  }
}

export const setAttributeFormErrorData = (attributesFormError: IAttributeError[]) => {
  return {
    type: SET_ATTRIBUTE_ERROR_FORM_DATA,
    attributesFormError
  }
}
export const addColumnAttribute = (attribute: IAttribute) => {
  return {
    type: ADD_COLUMN_ATTRIBUTE,
    columnAttribute: attribute
  }
}

export const setColumnAttributeFormData = (attributes: IAttribute[]) => {
  return {
    type: SET_COLUMN_ATTRIBUTE_FORM_DATA,
    columnAttributes: attributes
  }
}

export const setColumnAttributeFormErrorData = (attributesFormError: IAttributeError[]) => {
  return {
    type: SET_COLUMN_ATTRIBUTE_ERROR_FORM_DATA,
    columnAttributesFormError: attributesFormError
  }
}
export const setResourceNS = (resourceNS: IEntityNameSpace[]) => {
  return {
    type: SET_RESOURCE_NS,
    resourceNS
  }
}
export const setResources = (resources: IEnityResources[], resourcePagination: any) => {
  return {
    type: SET_RESOURCES,
    resources,
    resourcePagination
  }
}
export const setDPModel = (dpModelList: IDPModel) => {
  return {
    type: SET_DP_MODEL,
    dpModelList
  }
}
export const setRemoteDataAttributes = (data: any[], isPresent: boolean, pageNumber: number, totalCount: number) => {
  return {
    type: SET_REMOTE_URL_RESPONSE_DATA,
    data,
    isPresent,
    pageNumber,
    totalCount
  }
}
export const resetRemoteUrlResponseData = (isPresent: boolean) => {
  return {
    type: RESET_REMOTE_URL_RESPONSE_DATA,
    isPresent
  }
}
